<template>
<div class="shopMobTop">
    <div class="top">
        <img :src="require('@/common/images/shop/view-top.png')" alt="">
        <div class="shopName">{{smallPageName}}</div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shopMobTop',
    data() {
        return {
            shopName: '资鲸店铺'
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'smallPageName'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .shopMobTop{
        width: 15rem;
        .top{
            position: relative;
            img{
                width: 100%;
                height: 100%;
            }
            .shopName{
                width: 100%;
                position: absolute;
                bottom: 0.7rem;
                // left: 40%;
                text-align: center;
            }
        }
    }
</style>
